import type { Theme } from "@mui/material/styles";
import type { GroupPosition } from "@/pages/sy/utils/layerGroups";

export const getGroupFrameBorder = (theme: Theme) =>
  `3px solid ${theme.palette.grey[900]}`;

export const getGroupHeaderDivider = (theme: Theme) =>
  `1px solid ${theme.palette.grey[400]}`;

export const getGroupBackground = (theme: Theme) => theme.palette.grey[100];

export const getGroupFrameSx =
  (position?: GroupPosition, isSelected = false) =>
  (theme: Theme) =>
    position
      ? {
          ...(!isSelected && {
            "& td:first-of-type": { borderLeft: getGroupFrameBorder(theme) },
          }),
          "& td:last-of-type": { borderRight: getGroupFrameBorder(theme) },
          ...(position === "last" && {
            "& td": { borderBottom: getGroupFrameBorder(theme) },
          }),
        }
      : {};
